import { Box, Alert as MuiAlert, Snackbar, styled } from '@mui/material';
import { ComponentProps, createContext, PropsWithChildren, ReactNode, useState } from 'react';
import noop from 'lodash/noop';
import uniqueId from 'lodash/uniqueId';

const Alert = styled((props: ComponentProps<typeof MuiAlert>) => <MuiAlert {...props} />)(
  ({ theme }) => ({
    '&.MuiAlert-filledSuccess': {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.success.dark,
      fontWeight: 600
    }
  })
);

interface INotification {
  id: string;
  type: 'error' | 'info' | 'success' | 'warning';
  body: ReactNode;
}

export interface INotificationsContext {
  notifications: INotification[];
  showNotification: (notification: Omit<INotification, 'id'>) => void;
}
export const NotificationsContext = createContext<INotificationsContext>({
  notifications: [],
  showNotification: noop
});

// Провайдер для отображения уведомлений с помощью showNotification
export const NotificationsProvider = ({ children }: PropsWithChildren) => {
  const [notifications, setNotifications] = useState<INotification[]>([]);

  const removeById = (id: string) => {
    setNotifications(prev => prev.filter(notificationItem => notificationItem.id !== id));
  };

  const showNotification = (notification: Omit<INotification, 'id'>) => {
    const id = uniqueId();

    setNotifications(prev => ([...prev, { ...notification, id }]));

    setTimeout(() => { removeById(id); }, 5000);
  };

  const renderContent = () => (
    <NotificationsContext.Provider value={{ notifications, showNotification }}>
      {children}
      <Box sx={{
        position: 'fixed',
        top: -12,
        left: 300,
        right: 170
      }}>
        {notifications.map(notification => (
          <Snackbar open anchorOrigin={{ vertical: 'top', horizontal: 'left' }} sx={{ position: 'absolute', width: '100%' }}>
            <Box sx={{ width: '100%' }}>
              <Alert severity={notification.type}
                     variant='filled'
                     onClose={() => { removeById(notification.id); }}
                     sx={{ width: '100%' }}>
                {notification.body}
              </Alert>
            </Box>
          </Snackbar>
        ))}
      </Box>
    </NotificationsContext.Provider>
  );

  return renderContent();
};
